module.exports = __webpack_public_path__ + "../resources/img/ic_minus_dark.85bd11b2.svg";